import React from 'react';
import PropTypes from 'prop-types';
import './ProjectCard.css';

const ProjectCard = ({ type, media, title, description }) => {
  return (
    <div className="project-card">
      {type === 'video' ? (
        <video controls muted className="media-content">
          <source src={media} type="video/mp4" />
          <source src={media} type="video/quicktime" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <img src={media} alt={title} className="media-content" />
      )}
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

ProjectCard.propTypes = {
  type: PropTypes.string.isRequired,
  media: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ProjectCard;